import { Injectable } from '@angular/core';

@Injectable()
export class MediaPlanService {
  public defaultProgramId: any;

  constructor() {}

  getMediaPlanUgovorSettings() {
    return {
      additable: true,
      allFields: [
        this.getUgovorFieldSettings(),
        this.getProgramFieldSettings(),
        this.getKupacFieldSettings(),
        this.getDatumOdSettings(),
        this.getDatumDoSettings(),
        this.getSpotSettings(),
      ],
      completerMainAndSecond: true,
      completerMainField: 'BrojUgovora',
      completerSecondField: 'TipUgovoraId',
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [[], []],
              },
            ],
          },
        ],
        table: [],
        lookupTable: ['111-111-111'],
      },
      fromCode: 'MSUGO_UGO',
      group: 'MediaPlan',
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name: 'MediaPlan',
      relations: [
        this.getRelationSettings(
          'Ugovor',
          'BrojUgovora',
          'TipUgovoraId',
          [this.getUgovorFieldSettings().id],
          [this.getUgovorFieldSettings()]
        ),
        this.getRelationSettings(
          'Klijent',
          'BrojPodugovora',
          'KlijentNaziv',
          [this.getKupacFieldSettings().id],
          [this.getKupacFieldSettings()]
        ),
        this.getRelationSettings(
          'Spot',
          'Naziv',
          'Sifra',
          [this.getSpotSettings().id],
          [this.getSpotSettings()]
        ),
      ],
      title: 'Media Plan',
      type: 'mediaplan',
      path: 'MediaPlan.Ugovor',
      _id: '51073157',
    };
  }

  getUgovorFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Ugovor',
      entityType: 'Ugovor',
      id: '111-111-111',
      label: 'Ugovor',
      lookupFormCode: 'MSUGO_UGO',
      lookupFormName: 'Pregled ugovora',
      mandatory: false,
      name: 'Ugovor',
      path: null,
      type: 'completer',
      width: 10,
    };
  }

  getProgramFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Program',
      entityType: 'ProgramEnumMediaPlan',
      id: '222-222-222',
      label: 'Program',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'Program',
      path: null,
      type: 'comboFixed',
      width: 10,
    };
  }

  getKupacFieldSettings() {
    return {
      additable: false,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Klijent',
      entityType: 'Klijent',
      id: '444',
      label: 'Klijent',
      lookupFormCode: 'MSUGO_PUGKLI',
      lookupFormName: 'Pregled kupaca',
      mandatory: false,
      name: 'Klijent',
      path: null,
      type: 'completer',
      width: 10,
    };
  }

  getDatumOdSettings() {
    return {
      additable: true,
      dateRange: false,
      dbType: 'BIGINT',
      default: true,
      editable: true,
      fieldKey: 'datumOd',
      id: '555-555-555',
      javaFieldType: 'java.util.Date',
      label: 'Period',
      mandatory: true,
      name: 'DatumOd',
      path: 'Montaza',
      type: 'date',
      width: 92,
    };
  }

  getDatumDoSettings() {
    return {
      additable: true,
      dateRange: false,
      dbType: 'BIGINT',
      default: true,
      editable: true,
      fieldKey: 'datumDo',
      id: '666-666-666',
      javaFieldType: 'java.util.Date',
      label: 'Period',
      mandatory: true,
      name: 'DatumDo',
      path: 'Montaza',
      type: 'date',
      width: 92,
    };
  }

  getSpotSettings() {
    return {
      additable: false,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Spot',
      entityType: 'Spot',
      id: '777-777-777',
      label: 'Klijent',
      lookupFormCode: 'MSSPO_SPO',
      lookupFormName: 'Pregled spotova',
      mandatory: false,
      name: 'Spot',
      path: null,
      type: 'completer',
      width: 10,
    };
  }

  getBrojRezervacijaSettings() {
    return {
      additable: false,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'BrojRezervacija',
      entityType: 'BrojRezervacija',
      id: '123-123-123',
      label: 'Br rezervacija',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'BrojRezervacija',
      path: null,
      type: 'input',
      width: 10,
    };
  }

  getRelationSettings(
    name: string,
    completerMainField: string,
    completerSecondField: string,
    lookupTable: Array<any>,
    allFields
  ) {
    return {
      additable: true,
      allFields,
      completerMainAndSecond: true,
      completerMainField,
      completerSecondField,
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [[], []],
              },
            ],
          },
        ],
        table: [],
        lookupTable,
      },
      fromCode: '',
      group: name,
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name,
      relations: [],
      title: name,
      type: name,
      _id: '51073157',
    };
  }

  getRezervacije(
    raspored,
    ugovor,
    emisija,
    spot,
    existingRezervacije,
    kupac,
    program
  ) {
    const rezervacije = [];

    rezervacije.push({
      BrojUgovora: ugovor.BrojUgovora,
      EmisijaId: emisija.Id,
      EmisijaNaziv: emisija.Naziv,
      KupacNaziv: kupac.Naziv,
      KupacId: kupac.Id,
      ProgramNaziv: program.Naziv,
      ProgramId: program.Id,
      NacinEmitovanja: emisija.NacinEmitovanja,
      SpotId: spot.Id,
      SpotNaziv: spot.Naziv,
      SpotZeljenaPozicija: spot.ZeljenaPozicija,
      SpotSifra: spot.Sifra,
      SpotDatumKreiranja: spot.DatumKreiranja,
      UgovorId: ugovor.Id || ugovor.UgovorId,
      PodugovorId:
        kupac.PodugovorId !== null ? kupac.PodugovorId : ugovor.PodugovorId,
      BrojPodugovora: kupac.BrojPodugovora,
      OsnovnaCenaCPP: raspored.OsnovnaCenaCPP,
      OsnovnaCenaSek: raspored.OsnovnaCenaSek,
      DatumEmitovanja: raspored.DatumEmitovanja,
      VremeEmitovanja: raspored.VremeEmitovanja,
      Trajanje: raspored.Trajanje,
      SpotTrajanje: spot.TrajanjeSekunde,
      VrstaSpotaId: spot.VrstaSpotaId,
      VrstaSpota: spot.VrstaSpota,
      VremeTrajanjaServer: spot.VremeTrajanjaServer,
      EmisijaRasporedId: raspored.Id,
      EmisijaSifra: emisija.Sifra,
      Status: 0,
      rbr: this.getLastRbr(existingRezervacije) + 1,
    });

    return rezervacije;
  }

  setProgram(defaultProgramId) {
    this.defaultProgramId = defaultProgramId;
  }

  getStatusFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Status',
      id: '333-333-333',
      label: 'Status',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'Status',
      path: null,
      type: 'check',
      width: 10,
    };
  }

  getLastRbr(collection: Array<any>) {
    return Math.max(...collection.map(item => item.rbr));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/media-plan.service.ts